import PreviewAuthController from './PreviewAuthController';
import AuthenticationController from '../AuthenticationController';
import ErrorHandler from '../../error/ErrorHandler';
import System from '../../basic/System';
import t from '../../i18n/I18n';
import { AwaitSleep } from '../../util/FileInfoUtil';

/**
 * PreviewController is the static class which will be used to make any type of calls to the Preview Server.
 * Preview calls will include scrub calls, preview calls, user avatar, full username calls.
 * It will first iterate over all preview server urls for authentication and then only will make call forward for the actual action.
 */
export default class PreviewController {
  /**
   *
   * @returns {Promise.<*>}
   */
  static async doPreviewAuthentication() {
    try {
      return await PreviewAuthController.setupPreviewSessionAuth();
    } catch (e) {
      let data = {};
      data.errorMsg = e;
      return { success: false, data: data };
    }
  }

  static async issuePreviewServerAuth(displayError: boolean = false) {
    let { success, data } = await PreviewController.doPreviewAuthentication();
    if (success) {
      window.gs.isReviewServerLogged = true;
    } else {
      if (System.isBrowserApp()) {
        let retryCount = 0;
        while (retryCount < 3) {
          retryCount++;
          const result = await PreviewController.doPreviewAuthentication();
          if (result.success) {
            window.gs.isReviewServerLogged = true;
            success = true;
            break;
          }
          await AwaitSleep(500);
        }
      }
      if (!success) {
        window.gs.isReviewServerLogged = false;
        if (System.isBrowserApp()) {
          AuthenticationController.setLoggedInFail();
          if (displayError) {
            ErrorHandler.handleError(data ? data.errorMsg : t('UNKNOWN_PREVIEW_ERROR'));
          }
        } else if (!window.gs.sameCookieFound) {
          AuthenticationController.issueGetCredentials();
        }
      }
    }
    return success;
  }

  /**
   *
   * @returns {Promise}
   */
  static async checkPreviewAuthentication() {
    return await PreviewAuthController.checkAuthenticationAtPresentUrl();
  }
}

/**
 *
 * @type {Array}
 */
PreviewController.PENDING_PREVIEW_REQUESTS_QUEUE = [];
